import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileHeader from "../components/MobileHeader";
import FloatingActionButton from "../components/home/FloatingActionButton";

const About = () => (
    <>
        <div className="d-none d-lg-block">
            <Header />
        </div>
        <MobileHeader />
        {/* Hero Section */}
        <div className="bg-light text-center py-5 mb-4" style={{ backgroundImage: 'url(/path/to/your/hero-image.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', color: '#fff' }}>
            <div className="container" style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', padding: '2rem', borderRadius: '8px' }}>
                <h1 className="display-4 fw-bold">About Sway Your Way Tours</h1>
                <p className="lead">Crafting unforgettable travel experiences just for you.</p>
            </div>
        </div>

        <div className="container py-5">
            {/* Introduction Section */}
            <div className="row mb-5 align-items-center">
                <div className="col-md-6">
                    <h2>Welcome to Sway Your Way Tours</h2>
                    <p>
                        We are dedicated to providing memorable travel experiences, curated itineraries, and exceptional service. Our passion lies in helping you explore new destinations, immerse yourself in diverse cultures, and embark on adventures with utmost comfort and safety.
                    </p>
                    <p>
                        From breathtaking landscapes to vibrant cityscapes, we design journeys that inspire and leave lasting impressions. Let us turn your travel dreams into reality.
                    </p>
                </div>
                <div className="col-md-6 text-center">
                    {/* Placeholder for an image */}
                    <img src="/path/to/your/about-image1.jpg" alt="Travel collage" className="img-fluid rounded shadow" />
                </div>
            </div>

            {/* Mission and Vision Section */}
            <div className="row text-center mb-5">
                <div className="col-md-6 mb-4">
                    <div className="card h-100 shadow-sm">
                        <div className="card-body">
                            <h3 className="card-title">Our Mission</h3>
                            <p className="card-text">
                                To offer personalized and enriching travel experiences that connect people with the world's wonders, fostering understanding and appreciation across cultures.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 mb-4">
                    <div className="card h-100 shadow-sm">
                        <div className="card-body">
                            <h3 className="card-title">Our Vision</h3>
                            <p className="card-text">
                                To be the leading travel partner recognized for innovative tours, responsible practices, and creating journeys that inspire a lifetime of exploration and discovery.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Why Choose Us Section */}
            <div className="row mb-5">
                <div className="col-12 text-center mb-4">
                    <h2>Why Travel With Us?</h2>
                </div>
                {/* Feature 1 */}
                <div className="col-md-4 mb-3">
                    <div className="text-center">
                        <h4>Personalized Service</h4>
                        <p>Tailored itineraries and dedicated support to match your unique travel style.</p>
                    </div>
                </div>
                {/* Feature 2 */}
                <div className="col-md-4 mb-3">
                    <div className="text-center">
                        <h4>Local Expertise</h4>
                        <p>Insider knowledge and authentic experiences curated by passionate travel experts.</p>
                    </div>
                </div>
                {/* Feature 3 */}
                <div className="col-md-4 mb-3">
                    <div className="text-center">
                        <h4>Safety & Comfort</h4>
                        <p>Your well-being is our priority, ensuring safe and comfortable journeys.</p>
                    </div>
                </div>
            </div>

            {/* Contact Info */}
            <div className="text-center border-top pt-4">
                 <p>
                    Ready to start your adventure? <br />
                    <strong>Contact us:</strong> <a href="mailto:info@swayourwaytours.com">info@swayourwaytours.com</a>
                 </p>
            </div>
        </div>
        <FloatingActionButton />
        <Footer />
    </>
);

export default About;
